module.exports = __webpack_public_path__ + "static/media/uj_szerzigeny3.ce3d6a36.jpg";